export default "/images/fe-img-2.png?b2ab572ad60e3ee31ec4714fce5ed632";